import { useMemo } from 'react'
import { getFlightLoyaltyProductType } from 'lib/flights/flightUtils'
import LoyaltyPointsEarn from 'loyalty/components/Earn/LoyaltyPointsEarn'
import getLoyaltyEarnKey from 'loyalty/lib/pointsCalculation/earnKey/getLoyaltyEarnKey'

interface Props {
  flightDeal: App.FlightDeal
}

function FlightDealPoints({ flightDeal }: Props) {
  const pointsEarnCalculationRequests = useMemo<Array<App.LoyaltyPointsEarnCalculationRequest>>(() => {
    const isDomestic = flightDeal.originCountry === flightDeal.destinationCountry
    const type = getFlightLoyaltyProductType(flightDeal.fareClass.toLowerCase() || '', isDomestic)
    const earnKey = getLoyaltyEarnKey({
      loyaltyProductType: type,
      options: {
        originAirportCode: flightDeal.originAirportCode,
        destinationAirportCode: flightDeal.destinationAirportCode,
        carrier: flightDeal.carrier.code,
      },
    })

    return [{
      loyaltyProductType: type,
      price: flightDeal.perAdultPrice,
      earnKey,
      packageId: '',
      offerId: '',
    }]
  }, [flightDeal])

  return (
    <LoyaltyPointsEarn calculationRequests={pointsEarnCalculationRequests} calculationType="estimate" />
  )
}

export default FlightDealPoints
